var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"support"},[_c('div',{class:_vm.gridRowModifier},[(_vm.isLoggedIn)?[(!_vm.isLayoutMobile)?_c('div',{staticClass:"column large-4 support__sticky"},[_c('profile')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column large-8 small-12"},[_c('router-view')],1)]:[_c('div',{staticClass:"column small-12"},[_c('router-view')],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21cda316","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/support/support/support.vue
// module id = iWyB
// module chunks = 0